import { useState } from "react";
import { Link } from "react-router-dom";
import { doc, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "../firebase";
import MarketingNav from "../components/MarketingNav";
import "./LandingPage.css";

export default function WaitlistFan() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const cleanEmail = email.trim().toLowerCase();
    const cleanName = name.trim();

    if (!cleanName || !cleanEmail) {
      setError("Please enter your name and email.");
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(cleanEmail)) {
      setError("Please enter a valid email address.");
      return;
    }

    try {
      setLoading(true);
      setError("");

      await setDoc(
        doc(db, "waitlist_fans", cleanEmail),
        {
          email: cleanEmail,
          name: cleanName,
          approved: false,
          joinedAt: serverTimestamp(),
        },
        { merge: true }
      );

      setSuccess(true);
    } catch (err) {
      console.error("Fan waitlist signup error:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="lp-page">
      <MarketingNav />

      <main className="lp-main lp-form-page">
        <Link to="/welcome" className="lp-back">
          ← Back to home
        </Link>

        <div className="lp-waitlist-card">
          {success ? (
            <div className="lp-form-success">
              <div className="lp-form-success-icon" aria-hidden="true">✦</div>
              <h1 className="lp-form-page-title">You're on the list.</h1>
              <p>
                Thanks for joining early. Check your inbox — we just sent you a confirmation.
                We'll email again when your spot opens.
              </p>
              <Link to="/" className="lp-btn-primary" style={{ marginTop: "24px", display: "inline-flex" }}>
                Back to home
              </Link>
            </div>
          ) : (
            <>
              <p className="lp-form-eyebrow">Fan waitlist</p>
              <h1 className="lp-form-page-title">Join as a Fan</h1>
              <p className="lp-form-page-sub">
                Fans worldwide — get first access when we open the doors.
              </p>

              <form onSubmit={handleSubmit}>
                <div className="lp-field">
                  <label htmlFor="fan-name">Your name</label>
                  <input
                    id="fan-name"
                    type="text"
                    placeholder="Jane Doe"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    autoComplete="name"
                    required
                  />
                </div>

                <div className="lp-field">
                  <label htmlFor="fan-email">Email</label>
                  <input
                    id="fan-email"
                    type="email"
                    placeholder="you@email.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    autoComplete="email"
                    required
                  />
                </div>

                {error && <p className="lp-form-error">{error}</p>}

                <button type="submit" className="lp-btn-primary full" disabled={loading}>
                  {loading ? "Joining…" : "Join the waitlist"}
                </button>
              </form>

              <p className="lp-creator-note">
                By joining, you agree to receive waitlist updates. Unsubscribe anytime.
              </p>
            </>
          )}
        </div>
      </main>
    </div>
  );
}
